import { useTexts } from './useTexts';

export function useGetStateOptionsFromValues(states: string[]) {
  const texts = useTexts().states;
  return states.map((state) => ({
    value: state,
    label: state === 'approved' ? texts.approved : texts.rejected,
  }));
}
